import React, { useEffect, useState } from 'react';
import { Instagram, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'COLLECTIONS',
    href: '#collections'
  }, {
    name: 'ABOUT',
    href: '#about'
  }, {
    name: 'CONTACT',
    href: '#contact'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-sm py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-103">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-104">
          {/* Logo */}
          <a href="#" className="z-50" data-id="element-105">
            <h1 className={`font-serif text-xl md:text-2xl tracking-[0.2em] uppercase ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-106">
              Alejandro Noriega
            </h1>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-10" data-id="element-107">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-xs font-medium tracking-[0.15em] transition-colors hover:opacity-60 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-108">
                {link.name}
              </a>)}
            <a href="https://www.instagram.com/alenoriegaes" target="_blank" rel="noopener noreferrer" className={`transition-colors hover:opacity-60 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-109">
              <Instagram size={18} data-id="element-110" />
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className={`md:hidden z-50 ${isScrolled || isMobileMenuOpen ? 'text-charcoal' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-111">
            {isMobileMenuOpen ? <X size={24} data-id="element-112" /> : <Menu size={24} data-id="element-113" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-114">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-30 bg-white flex flex-col items-center justify-center space-y-8" data-id="element-115">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-charcoal text-lg font-medium tracking-[0.2em] uppercase" data-id="element-116">
                {link.name}
              </a>)}
            <a href="https://www.instagram.com/alenoriegaes" target="_blank" rel="noopener noreferrer" className="text-charcoal flex items-center space-x-2 mt-4" data-id="element-117">
              <Instagram size={24} data-id="element-118" />
              <span className="text-sm tracking-widest uppercase" data-id="element-119">Follow</span>
            </a>
          </motion.div>}
      </AnimatePresence>
    </>;
}